import { useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";

const useDefaultSection = <T extends string>({
  root,
  defaultRoute,
  selected,
  sections,
}: {
  root: string;
  defaultRoute: T;
  selected?: T;
  sections: T[];
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname.includes(root) &&
      (!selected || !sections.includes(selected))
    ) {
      navigate(defaultRoute, { replace: true });
    }
  }, [selected]);
};

export default useDefaultSection;
